import Component from '../abstracts/Component';
import { Select2Init } from '../utils/Select2Init';
import { MODAL_DIALOG_EVENTS } from '../components/ModalDialogComponent';

export default class ListingProductCard extends Component {

    get SELECTORS() {
        return {
            code: '[data-card-code]',
            dialog: '.modal-dialog',
            sizeSelect: '.sizes-select'
        }
    }

    get CLASSES() {
        return {}
    }

    constructor(el) {
        super(el);
        this.dialog = this.$component.querySelector(this.SELECTORS.dialog);

        this.code = this.dialog && this.dialog.dataset.dialog;
    }

    setupSelect() {
        const select = this.dialog.querySelector('select');
        $('select:not(#countries-select)').val(null).trigger('change');

        Select2Init(this.dialog, {
            escapeMarkup: (markup) => {
              return markup;
            },
            templateSelection: (option) => {
              if (option.element) {
                if (option.element.dataset.lastItem == 'true') {
                    return  `
                        <div class='item-last'>
                            <span>${option.text}</span>
                            <span>${option.element.dataset.translationLastitem}</span>
                        </div>`;
                }
                if (option.element.dataset.notAvailable == 'true') {
                    return `
                        <div class='item-unavailable'>
                            <span>${option.text}</span>
                            <span class='notify-me'>
                                <span class='icon-mail'></span>
                                ${option.element.dataset.translationUnavailable}
                            </span>
                        </div>`;
                } else {
                    return `<div class=''><span>${option.text}</span></div>`;
                }
              } else {
                return option.text;
              }
            },
            templateResult: (option) => {
              if (option.element) {
                if (option.element.dataset.lastItem == 'true') {
                    return `
                        <div
                            id='${option.element.dataset.productCode}'
                            class='size-product-option item-last'
                            data-product-code='${option.element.dataset.productCode}'
                        >
                            <span>${option.text}</span>
                            <span>${option.element.dataset.translationLastitem}</span>
                        </div>`;
                }
                if (option.element.dataset.notAvailable == 'true') {
                    return `
                        <div
                            id='${option.element.dataset.productCode}'
                            class='size-product-option item-unavailable'
                            data-product-code='${option.element.dataset.productCode}'
                        >
                            <span>${option.text}</span>
                            <span class='notify-me'>
                                <span class='icon-mail'></span>
                                ${option.element.dataset.translationUnavailable}
                            </span>
                        </div>`;
                } else {
                    return `
                        <div
                            id='${option.element.dataset.productCode}-${Math.random()}'
                            class='size-product-option item-available'
                            data-product-code='${option.element.dataset.productCode}'
                        >
                            <span>${option.text}</span>
                        </div>`;
                }
              }
            }
        });
        const isVariant = this.code.length !== 13;
        if (isVariant) $(select).val(this.code).trigger('change');
    }

    openSelect() {
        // we need to reselect the element via jQuery because select2 needs to work with jQuery elements
        let select = $(this.SELECTORS.dialog).find(this.SELECTORS.sizeSelect);
        select.each((i, el) => {
            if (el.dataset.selectId === `select_${this.code}`) $(el).select2('open');
        });
    }

    bindEvents() {
        this.$on(MODAL_DIALOG_EVENTS.OPEN, ({ payload }) => {
            if (payload.id === this.code) this.setupSelect();
            setTimeout(() => {
                this.$emit(MODAL_DIALOG_EVENTS.OPENED, payload);
            }, 50);
        });

        this.$on(MODAL_DIALOG_EVENTS.OPENED, ({ payload }) => {
            if (payload.id === this.code) this.openSelect();
        })
    }

    render() {
        this.log('Render ListingProductCard...');
        this.bindEvents();
    }

}